import React from "react";
import { Button } from "components/core/Button";
import Column from "components/core/Page/Column";
import { Mail } from "components/core/Icons";

function MailButton() {
	const sendEmailHandler = () => {
		window.location.href = "mailto:customerhelp@storage.com";
	};
	return (
		<Column
			large={4}
			className="margin-top"
		>
			<Button
				theme="primary"
				onClick={() => sendEmailHandler()}
				size="small"
			>
				<Mail fill="white" />
				Send Us An Email
			</Button>
		</Column>
	);
}

export default MailButton;
